// 
import styles from './styles.module.scss';

const Footer = (): JSX.Element => (
  <div className={styles.footer}>
    <div>
      <img src='/logo192.png' alt="logo" />
    </div>
  </div>
);

export default Footer;